import { io } from "socket.io-client";
import { url } from "src/Helpers/utils/constants";

// Replace with your backend URL
export const socket = io(
	url /* , {
	autoConnect: false, // Prevent auto-connection on import
	transports: ["websocket"], // Use WebSocket protocol
} */
);

export const connectSocket = () => {
	if (!socket.connected) {
		socket.connect();
	}
};

export const disconnectSocket = () => {
	if (socket.connected) {
		socket.disconnect();
	}
};
